<p-dialog
        [header]="'Are you sure you want to approve this image for ALL makes?'"
        [modal]="true"
        [(visible)]="dialogVisible"
        [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }"
        [draggable]="false"
        [resizable]="false"
        [dismissableMask]="true"
        (onHide)="close()"
>
    @if (this.failed) {
        <p-messages
                [(value)]="msgs"
                [enableService]="false"
                [closable]="false" />
    }
    <div class="flex justify-content-end gap-2">
        <p-button
                label="Cancel"
                (click)="close()"
                severity="secondary"/>
        <p-button
                [loading]="loading"
                label="Yes"
                (click)="approve()"/>
    </div>
</p-dialog>